import type { TPaymentMethods } from "@features/checkout/types";
import { isNotNullish } from "../isNotNullish";

type HeapAdyenPaymentMethod = TPaymentMethods & { brand?: string | null };

// HEAP sends brand: null, which Adyen Web reports as brands: [null] and its analytics API rejects (29_001).
export const toAdyenPaymentMethods = (paymentMethods: TPaymentMethods[]): TPaymentMethods[] =>
    paymentMethods.map(({ brand, brands, ...paymentMethod }: HeapAdyenPaymentMethod) => ({
        ...paymentMethod,
        ...(isNotNullish(brand) && { brand }),
        ...(brands && { brands: brands.filter(isNotNullish) }),
    }));
